var _line, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScrollDownArrowBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.5296,
    y1: 0.611755,
    x2: 18.5296,
    y2: 49.7053,
    stroke: "black",
    strokeWidth: 3.77643
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5296 48.4689C28.0965 30.3421 36.3627 25.8104 39.2999 25.8104",
    stroke: "black",
    strokeWidth: 3.77643
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5296 48.4689C11.9838 30.3421 3.6337 25.8104 0.276872 25.8104",
    stroke: "black",
    strokeWidth: 3.77643
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDownArrowBlack);
export default __webpack_public_path__ + "static/media/scrollDownArrowBlack.926e9ad361de731ad10bc760b73d3d63.svg";
export { ForwardRef as ReactComponent };